import React from 'react';
import moment from 'moment';
import Container from '../editor/container';
import NewsEditor from '../editor';
import '../editor/styles.css';
import parseContent from '../editor/parseContent';

class Component extends React.Component {
  initialState = {
    id: false,
    target_role_id: 0,
    target_wids: '',
    target_networks: '',
    content: '',
    contentObj: [],
    mode: 'edit',
    saved: -1,
    error: ''
  };

  state = this.initialState;

  componentWillMount() {
    this.setState({
      content: '',
      contentObj: {
        type: 'container',
        content: [
          {
            type: 'row',
            content: [
              {
                type: 'col',
                content: {
                  type: 'text',
                  content: `
                    <h6>Congratulations, you just one a FREE Sale for your hard work!</h6>
                    <div><h6>Check your statistics !</h6></div>
                  `
                }
              }
            ]
          }
        ]
      },
      selected: null,
      mode: 'edit'
    });
  }

  save = (e) => {
    e.preventDefault();
    let params = {
      target_role_id: 0,
      target_wids: this.props.wids,
      target_networks: '',
      content: JSON.stringify(this.state.contentObj)
    };
    this.setState({ saving: true, error: '', saved: -1 });
    this.props.api('news/save', params).then((res) => {
      console.log('res', res);
      if (res && res.result == 1) {
        this.setState({
          saving: false,
          saved: this.props.wids.split(',').length,
          mode: 'render'
        });
      } else {
        this.setState({
          saving: false,
          error: (res && res.error && res.error.toString()) || JSON.stringify(res)
        });
      }
    });
  };

  handleChange = (event) => {
    const target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    value = target.type === 'file' ? target.files[0] : value;
    this.setState({
      [target.name]: value
    });
    event.preventDefault && event.preventDefault();
  };

  render() {
    let roleId = this.props.user.role_id;
    let editMode = this.state.mode == 'edit';
    let { saved, error } = this.state;
    return (
      <form class={'modal fade black-overlay show d-block'} onSubmit={this.save}>
        <div class='modal-dialog modal-lg'>
          <div class='modal-content'>
            <div class='modal-body p-2'>
              <NewsEditor
                data={this.state.contentObj}
                mode={this.state.mode}
                onChange={this.handleChange}
              />
            </div>
            <div class='modal-footer d-block'>
              <div class='row'>
                <div class='col-sm-3'>
                  {!!error && <div>{error}</div>}
                  {saved >= 0 && <div>Sent: {saved}</div>}
                </div>
                <div class='col-sm-5 text-center'>
                  <div class='btn-group'>
                    <button
                      class={'btn primary' + (editMode ? ' active' : '')}
                      name='mode'
                      value='edit'
                      onClick={this.handleChange}
                    >
                      Editor
                    </button>
                    <button
                      class={'btn primary' + (!editMode ? ' active' : '')}
                      name='mode'
                      value='render'
                      onClick={this.handleChange}
                    >
                      Preview
                    </button>
                  </div>
                </div>
                {saved === -1 && (
                  <div class='col-sm-4 text-right'>
                    <button type='button' class='btn warning' onClick={this.props.onClose}>
                      Cancel
                    </button>
                    <button type='submit' class='btn primary ml-2'>
                      Send
                    </button>
                  </div>
                )}
                {saved >= 0 && (
                  <div class='col-sm-4 text-right'>
                    <button type='button' class='btn warning' onClick={this.props.onClose}>
                      Close
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

import api from 'src/actions/api';
import setState from 'src/actions/state';
import { connect } from 'react-redux';

export default connect(
  function (state) {
    return {
      saveApiState: state.api['news_save'] || state.api.initial,
      state: state.state['news'] || state.state.initial,
      user: state.session.user
    };
  },
  {
    api,
    setState: setState('news_find_by_user')
  }
)(Component);
